import React, {useEffect, useState} from 'react';
import {getAllAdFees, getAllApprovedAds} from '../../../../Store/Actions';
import {useDispatch, useSelector} from 'react-redux';
import ApprovedAdsListing from '../../../../Components/UserComponents/Ads/ApprovedAdsListing';
import {createSelectionOptionsUtil} from '../../../../Util/commonUtility';

const ApprovedAdsContainer = () => {
  const {getApprovedAds} = useSelector(({ads}) => ads);
  const [allApprovedAdsData, setAllApprovedAdsData] = useState([]);
  const {allAdFees} = useSelector(({adFees}) => adFees);
  const [adFeesOptions, setAdFeesOptions] = useState([]);
  const [zeroFeeData, setZeroFeeData] = useState([]);
  let dispatch = useDispatch();

  useEffect(() => {
    if (getApprovedAds) {
      const Data = getApprovedAds?.data?.ads;
      setAllApprovedAdsData(Data);
    } else {
      dispatch(getAllApprovedAds());
    }
  }, [getApprovedAds]);

  useEffect(() => {
    if (allAdFees) {
      setAdFeesOptions(
        createSelectionOptionsUtil(
          allAdFees?.data?.adFees,
          'id',
          'details',
          'fee',
        ),
      );
      setZeroFeeData(allAdFees?.data?.adFees?.filter((obj) => obj?.fee === 0));
    } else {
      dispatch(
        getAllAdFees(
          {
            page: 1,
            pagecount: 100,
          },
          '',
          '',
          '',
        ),
      );
    }
  }, [allAdFees]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, []);
  return (
    <div>
      <ApprovedAdsListing
        allApprovedAdsData={allApprovedAdsData}
        adFeesOptions={adFeesOptions}
        zeroFeeData={zeroFeeData}
      />
    </div>
  );
};

export default ApprovedAdsContainer;
